import { useTranslation } from "react-i18next";
import { useForm } from "react-hook-form";
import { useNavigate, useParams } from "react-router-dom";
import { useState, useRef, useEffect, useCallback } from "react";
import { useAlert } from "../../../../../contexts/alert-context";
import { SpecialTechnologyDTO } from "../special-technologies-DTO";
import {
  addNew,
  getSpecialTechnologyById,
} from "../special-technologies-service";
import { extractSubstringFile } from "../../../../../services/string-treatment";
import {
  SparkIcon,
  SparkTableBody,
  SparkTableCell,
  SparkTableRow,
} from "@bosch-web-dds/spark-ui-react";
import UploadFileOrImage from "../../../../../components/UploadFileAndImagesComponent/UploadFileOrImagesComponent";

interface ModalProps {
  onClose: () => void;
  contactId: string;
}

const SpecialTechnologyForm: React.FC<ModalProps> = ({
  onClose,
  contactId,
}) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { id } = useParams<{ id: string }>();
  const { setAlert } = useAlert();
  const [specialTechnology, setSpecialTechnology] =
    useState<SpecialTechnologyDTO | null>(null);

  const {
    register,
    handleSubmit,
    formState: { errors },
    setValue,
  } = useForm<SpecialTechnologyDTO>();

  const [selectedImages, setSelectedImages] = useState<File[]>([]);
  const [removedFiles, setRemovedFiles] = useState<string[]>([]);

  const handleImageChange = useCallback(
    (files: File[], removedFiles: string[]) => {
      setSelectedImages(files);
      if (removedFiles.length > 0) {
        setRemovedFiles(removedFiles);
      }
    },
    []
  );


  useEffect(() => {
    if (contactId) {
      getSpecialTechnologyById(contactId).then((data) => {
        if (data) {
          setSpecialTechnology(data);
          Object.entries(data).forEach(([key, value]) => {
            if (typeof value === "object" && value !== null) {
              Object.entries(value as Record<string, unknown>).forEach(
                ([subKey, subValue]) => {
                  setValue(
                    `${key}.${subKey}` as keyof SpecialTechnologyDTO,
                    subValue as any
                  );
                }
              );
            } else {
              setValue(key as keyof SpecialTechnologyDTO, value as any);
            }
          });
        }
      });
    }
  }, [id, setValue]);

  const onSubmit = async (contact: SpecialTechnologyDTO) => {
    try {
      if (id) {
        await addNew(contact, id, selectedImages,removedFiles);
        setAlert({ text: t("alert-successfully-registered"), type: "success" });
        onClose();
      }
    } catch (e) {
      console.error("Erro ao cadastrar: ", e);
      setAlert({ text: `${t("alert-error-registered")}:`, type: "error" });
    }
  };

  return (
    <div className="modal-content">
      <form onSubmit={handleSubmit(onSubmit)}>
        <div className="form-fields flex-column">
          <h2>{t("label-special-technology")}</h2>

          <div className="flex-column">
            <label htmlFor="technology">{`${t("label-special-technology")}*`}</label>
            <input
              placeholder={t("placeholder.generalEmpty")}
              type="text"
              id="technology"
              {...register("specialTechnologyInfo.specialTechnologyTitle", {
                required: true,
              })}
            />
            {errors.specialTechnologyInfo?.specialTechnologyTitle && (
              <span>{t("error-input-required")}</span>
            )}
          </div>

          <div className="flex-column">
            <label htmlFor="description">{`${t("label-description")}*`}</label>
            <textarea
              placeholder={t("placeholder.generalEmpty")}
              id="description"
              {...register("specialTechnologyInfo.specialTechnology", {
                required: true,
              })}
            />
            {errors.specialTechnologyInfo?.specialTechnology && (
              <span>{t("error-input-required")}</span>
            )}
          </div>

          <div className="form-fields flex-column">
            <div className="flex-column">
              <label htmlFor="observations">
                {t("label-general-observations")}
              </label>
              <textarea
                placeholder={t("placeholder.observations")}
                id="observations"
                {...register("observations.observations")}
              />
            </div>
          </div>

          <br />


          <div className="flex-column">
            
            <UploadFileOrImage
              onlyImages={false}
              onSave={(itens, removedFiles) =>
                handleImageChange(itens, removedFiles)
              }
              initialSavedFiles={specialTechnology?.specialTechnologyInfo?.files || []}
              
            />
           
          </div>

          

          <hr></hr>

          <div className="flex-row buttons-section">
            <button className="neutral-white" onClick={onClose} type="button">
              {t("label-back")}
            </button>
            <button className="blue" type="submit">
              {t("label-save")}
            </button>
          </div>
        </div>
      </form>
    </div>
  );
};

export default SpecialTechnologyForm;
